/**
 * Redux Store Configuration
 * This module configures the Redux store for the application,
 * including middleware and state persistence.
 */

import { configureStore } from '@reduxjs/toolkit';
import { persistReducer, persistStore } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import adminReducer from './adminReducer';
import aopReducer from './aopDataReducer'; // <--- ADDED IMPORT
import commentsReducer from './commentSlice';
import employeeDataSlice from './employeeDataSlice';
import formReducer from './formReducer';
import glossaryReducer, { getGlossary } from './glossaryReducer';
import industryReducer from './industrySlice';
import multiAopReducer from './multiAopSlice';
import PmsUsReducer from './PmsUs'; // Ensure this is the correct slice you want to persist
import provisionAdminReducer from './provisionAdminSlice';
import provisionUserReducer from './provisionUserSlice';
import reportPreloadReducer from './reportPreloadSlice';
import UserReducer from './userReducer';

// Configuration for Redux state persistence.
const persistConfig = {
  key: 'user', // Use 'user' to only persist the user slice
  storage,
  // Power BI embed tokens grant access to report data; keep them in memory
  // only instead of writing them to localStorage (where they would outlive
  // the session). They are re-fetched on reload.
  blacklist: ['reportEmbedToken'],
};

// Create a persisted reducer with the user reducer
const persistedReducer = persistReducer(persistConfig, UserReducer);

// Configure the Redux store with the persisted reducer and other reducers
export const store = configureStore({
  reducer: {
    PowerBi: persistedReducer,
    AdminPageData: adminReducer,
    glossary: glossaryReducer,
    Form: formReducer,
    comments: commentsReducer,
    pms: PmsUsReducer,
    employeeData: employeeDataSlice,
    industry: industryReducer,
    provisionAdmin: provisionAdminReducer,
    provisionUser: provisionUserReducer,
    aop: aopReducer, // <--- ADDED REDUCER KEY
    multiAop: multiAopReducer,
    reportPreload: reportPreloadReducer, // not persisted: live iframe status
  },
  // Middleware configuration
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

// Create a Redux persistor for the store
export const persistor = persistStore(store);
export { getGlossary };
